exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* prevents bg color from leaking outside the border */\n\n/* Override Bootstrap buttons */\n\n.bootstrap-agendor .userSelector {\n  background: #f8f9fa;\n  padding: 10px;\n}\n\n.bootstrap-agendor .userSelector-search {\n  display: block;\n  height: 30px;\n  width: 100%;\n  padding: 6px 12px;\n  border: 1px solid #ccc;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  -ms-border-radius: 4px;\n  border-radius: 4px;\n  font-size: 12px;\n}\n\n.bootstrap-agendor .userSelector-list {\n  overflow-y: auto;\n  overflow-x: hidden;\n  max-height: 145px;\n}\n\n.bootstrap-agendor .userSelector-userName {\n  color: #565c63;\n  margin: 0 4px 0 8px;\n}\n\n.bootstrap-agendor .userSelector-userJob {\n  color: #777777;\n  line-height: 30px;\n  max-width: 40px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /~/css-loader!/~/resolve-url-loader!/~/sass-loader!./app/assets/css/sass/components/user-selector.scss
// module id = 597
// module chunks = 0